import { render } from "./FooterNWICustom.vue?vue&type=template&id=6f831f56&scoped=true"
import script from "./FooterNWICustom.vue?vue&type=script&lang=js"
export * from "./FooterNWICustom.vue?vue&type=script&lang=js"

import "./FooterNWICustom.vue?vue&type=style&index=0&id=6f831f56&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src192932826/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f831f56"]])

export default __exports__